<template>
    <div class="area-message">
      <h5>{{client.full_name}}</h5>
      <messages v-if="chat_id" :chat_id="chat_id"/>
    </div>
</template>
<script>

import messages from '@/components/Pupils/Chat/Messages';

export default {
  props: {
    client:{
      default:null
    },
  },
  computed:{
    
  },
  watch:{
     client: {
      handler: function (val) {
        if (val.chat) {
            this.chat_id= val.chat.id;
        }
         else alert('У пользователя не создан Чаты');
      },
      deep: true,
    },
  },
  components: {
    messages
  },
  methods: {
  },
  created(){
    if (this.client && this.client.chat){
           this.chat_id = this.client.chat.id;
      } else  {
            alert('У пользователя не создан ЧАТы');
      }
  },
  data() {
    return {
        chat_id:null
    };
  },
};
</script>

